function RedirectToUrl() 
{
  window.location.replace('https://perbit.com');
  return <div>Redirecting...</div>;
}
  
export default RedirectToUrl;